import React from 'react'
import styles from './pupil-entry.styles'
import injectSheet from 'react-jss'
import { Cell, TableRow } from 'pobble-components/dist/table'
import Checkbox from 'pobble-components/dist/form-elements/form-checkbox'
import UserName from 'pobble-components/dist/user-name'
import AgeGroup from 'pobble-components/dist/age-group'
import CircleStatus from 'pobble-components/dist/circle-status'
import ContextMenu from './context-menu/context-menu.container'
import Groups from './groups/groups'
import Spinner from 'pobble-components/dist/spinner'
import classNames from 'classnames'
import PobbleLink from 'pobble-components/dist/pobble-link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt'
import { Link } from 'react-router-dom'

const PupilEntry = ({
  id,
  classes,
  selected,
  name,
  age,
  groups,
  permission,
  passcode,
  works,
  onChange,
  onPupilClick,
  pending,
  displayName
}) => (
  <TableRow pending={pending}>
    <Cell className={classes.center}>
      <Checkbox onChange={onChange} checked={selected} />
    </Cell>
    <Cell>
      {onPupilClick && (
        <span
          className={classNames(
            classes.usernameWrapper,
            classes.userNameHighlight
          )}
          onClick={onPupilClick}>
          <UserName>{name}</UserName>
        </span>
      )}
      {!onPupilClick && <UserName>{name}</UserName>}
    </Cell>
    <Cell>
      {onPupilClick && (
        <span className={classes.usernameWrapper} onClick={onPupilClick}>
          {displayName}
        </span>
      )}
      {!onPupilClick && displayName}
    </Cell>
    <Cell className={classes.center}>
      <AgeGroup data={age} />
    </Cell>
    <Cell className={classes.center}>
      <Groups>{groups}</Groups>
    </Cell>
    <Cell className={classes.center}>
      <CircleStatus status={permission} />
    </Cell>
    <Cell className={classes.right}>
      {!!works && (
        <PobbleLink as={Link} to={`pupil/${id}/work`}>
          {works} <FontAwesomeIcon icon={faFileAlt} />
        </PobbleLink>
      )}
    </Cell>
    <Cell className={classes.center}>{passcode}</Cell>
    <Cell className={classes.right}>
      {pending ? (
        <Spinner className={classes.updatingSpinner} />
      ) : (
        <ContextMenu id={id} />
      )}
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(PupilEntry)
